import axios from "axios";
import { getBackendMainUrl } from "./global.ts";
import {
  SynthesizeParams,
  SynthesizeResponse,
  VoiceType,
} from "@/components/tools/Polly/types.ts";

const BASE_URL_API = getBackendMainUrl + "/api/polly";
const HEADERS = {
  headers: {
    "content-type": "application/json",
    Authorization: localStorage.getItem("authorization"),
  },
};

// Fonctions pour interagir avec l'API
export const pollyApi = {
  // Synthétiser le texte en audio (retourne du base64)
  synthesize: async (params: SynthesizeParams): Promise<SynthesizeResponse> => {
    const response = await axios.post<SynthesizeResponse>(
      BASE_URL_API + "/synthesize",
      params,
      { ...HEADERS }
    );
    return response.data;
  },

  // Méthode pour obtenir le blob audio directement
  getSynthesizeBlob: async (params: SynthesizeParams): Promise<Blob> => {
    const response = await axios.post(
      BASE_URL_API + "/synthesize-file",
      params,
      {
        responseType: "blob",
        ...HEADERS,
      }
    );
    return response.data;
  },

  // Obtenir la liste des voix disponibles
  getVoice: async (languageCode: string): Promise<any> => {
    try {
      const response = await axios.get(
        `${BASE_URL_API}/models/${languageCode}`,
        { ...HEADERS }
      );

      // Normaliser la réponse quelle que soit sa structure
      let voices = [];
      if (response.data?.success && Array.isArray(response.data.voices)) {
        voices = response.data.voices;
      } else if (Array.isArray(response.data)) {
        voices = response.data;
      } else if (response.data?.Voices && Array.isArray(response.data.Voices)) {
        voices = response.data.Voices;
      }

      // Normaliser les voix pour avoir des propriétés cohérentes
      const normalizedVoices = voices.map((voice: VoiceType) => ({
        Id: voice.Id || voice.id || voice.VoiceId,
        Name: voice.Name || voice.name,
        Gender: voice.Gender || voice.gender,
        LanguageCode: voice.LanguageCode || voice.languageCode,
        LanguageName: voice.LanguageName || voice.languageName,
        SupportedEngines: voice.SupportedEngines || voice.supportedEngines,
      }));

      return {
        success: true,
        voices: normalizedVoices,
      };
    } catch (error) {
      console.error("Erreur dans getVoice:", error);
      return {
        success: false,
        voices: [],
        error: (error as Error).message,
      };
    }
  },
};
